<div class="tab-pane" role="tabpanel" id="condiciones">
    <fieldset id="agregar_condiciones" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Condiciones del Anteproyecto</strong></h3>
                        <div><label>(Tramite previo Conjunto o simultaneo al Permiso)</label></div>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group col-md-12" align="left">
                                <div>
                                    <mat-checkbox id="condicion1" name="condicion1" formControlName="condicion1" (change)="add_condiciones()" value="SI">Fusion</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12" align="left">
                                <div>
                                    <mat-checkbox id="condicion2 " name="condicion2" formControlName="condicion2" (change)="add_condiciones()" value="SI">Subdivision</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12 " align="left ">
                                <div>
                                    <mat-checkbox id="condicion3 " name="condicion3" formControlName="condicion3" (change)="add_condiciones()" value="SI">loteo</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12 " align="left ">
                                <div>
                                    <mat-checkbox id="condicion4 " name="condicion4" formControlName="condicion4" (change)="add_condiciones()" value="SI">Division Afecta</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12 " align="left ">
                                <div>
                                    <mat-checkbox id="condicion5 " name="condicion5" formControlName="condicion5" (change)="add_condiciones()" value="SI">Estudios Fundados por areas de Riesgo (Art. 5.1.15 OGUC)</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12 " align="left ">
                                <div>
                                    <mat-checkbox id="condicion6 " name="condicion6" formControlName="condicion6" (change)="add_condiciones()" value="SI">Cambios de Destino</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group col-md-12 " align="left ">
                                <div>
                                    <mat-checkbox id="condicion7 " name="condicion7" formControlName="condicion7" (change)="add_condiciones()" value="SI">Otros (Especificar)</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>